// src/PartnerDashboardMitham.jsx
import React, { useEffect, useState, useMemo } from "react";
import { db, storage } from "./firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  doc,
  getDoc,
  setDoc,  addDoc, // ✅ أضف هذا
} from "firebase/firestore";
import {
  Paper,
  Typography,
  Box,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
    MenuItem, 
} from "@mui/material";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import UploadPreview from "./components/UploadPreview";

const PartnerDashboardMitham = () => {
  const PARTNER_ID = "mitham";
  const PARTNER_NAME = "ميثم برحيه";

  const [orders, setOrders] = useState([]);
  const [partner, setPartner] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [uploading, setUploading] = useState(false);
  // 🔹 مدفوعات الشريك
const [payments, setPayments] = useState([]);

// 🔹 Dialog دفع العمولة
const [payDialogOpen, setPayDialogOpen] = useState(false);
const [paymentType, setPaymentType] = useState(""); // full | partial
const [paymentMethod, setPaymentMethod] = useState(""); // cash | transfer
const [paymentAmount, setPaymentAmount] = useState("");
const [receiptFile, setReceiptFile] = useState(null);
const [savingPayment, setSavingPayment] = useState(false);

  useEffect(() => {
    fetchPartner();
    fetchOrders();
    fetchPayments(); // ✅ أضف هذا السطر

  }, []);

  // =============================
  // 📌 جلب بيانات ميثم من Firestore
  // =============================
  const fetchPartner = async () => {
    const partnerRef = doc(db, "partners", PARTNER_ID);
    const snap = await getDoc(partnerRef);

    if (snap.exists()) {
      setPartner(snap.data());
    } else {
      const defaultData = {
        name: PARTNER_NAME,
        phone: "",
        website: "",
        notes: "",
        logoUrl: "",
        joinedAt: new Date().toISOString(),
      };
      await setDoc(partnerRef, defaultData);
      setPartner(defaultData);
    }
  };

  // =============================
  // 📌 رفع اللوغو
  // =============================
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const storageRef = ref(storage, `partners/${PARTNER_ID}/logo.png`);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      await setDoc(
        doc(db, "partners", PARTNER_ID),
        { ...partner, logoUrl: downloadURL },
        { merge: true }
      );

      setPartner((prev) => ({ ...prev, logoUrl: downloadURL }));
    } catch {
      alert("خطأ أثناء رفع اللوغو");
    } finally {
      setUploading(false);
    }
  };

  // =============================
  // 📌 حفظ بيانات البروفايل
  // =============================
  const handleSaveProfile = async () => {
    await setDoc(doc(db, "partners", PARTNER_ID), partner, { merge: true });
    setOpenProfile(false);
  };

  // =============================
  // 📌 جلب الطلبات الخاصة بمصدر "ميثم برحيه"
  // =============================
  const fetchOrders = async () => {
  const q = query(
  collection(db, "orders"),
  where("source", "in", ["ميثم برحيه", "ارت تاتش"]),
  orderBy("createdAt", "desc")
);


    const snap = await getDocs(q);
    setOrders(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  };
// =============================
// 📌 جلب مدفوعات الشريك
// =============================
const fetchPayments = async () => {
  const q = query(
    collection(db, "partnerPayments"),
    where("partnerId", "==", PARTNER_ID)
  );

  const snap = await getDocs(q);
  setPayments(snap.docs.map((d) => d.data()));
};

  const totalOrders = orders.length;
  const totalAmount = orders.reduce((sum, o) => sum + (o.price || 0), 0);
const totalCommission = orders.reduce((sum, o) => {


  // 🔹 إذا مصدر الطلب ارت تاتش → العمولة 5%
  if (o.source === "ارت تاتش") {
    return sum + (o.price * 0.05);
  }

  // 🔹 إذا مصدر الطلب ميثم برحيه → استخدم النسبة المدخلة
  if (o.maythamCommission) {
    return sum + (o.price * (o.maythamCommission / 100));
  }

  return sum;
}, 0);

// =============================
// 📌 حساب المدفوع والمتبقي
// =============================
const totalPaid = payments.reduce(
  (sum, p) => sum + (p.amount || 0),
  0
);

const remainingCommission = Math.max(
  totalCommission - totalPaid,
  0
);

const monthlyStats = useMemo(() => {
  const map = {};

  orders.forEach((order) => {
    const date = order.createdAt?.toDate?.() || new Date();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const key = `${year}-${month}`;

    if (!map[key]) {
      map[key] = {
        year,
        month,
        count: 0,
        total: 0,
        commission: 0, // ✅ أضفنا العمولة
      };
    }

    map[key].count++;
    map[key].total += order.price || 0;

    // ✅ حساب العمولة الصحيح
    if (order.source === "ارت تاتش") {
      map[key].commission += order.price * 0.05;
    } else if (order.maythamCommission) {
      map[key].commission +=
        order.price * (order.maythamCommission / 100);
    }
  });

  return Object.values(map).sort(
    (a, b) => b.year - a.year || b.month - a.month
  );
}, [orders]);


  const getCardColor = (status) =>
    status === "عند التوصيل" || status === "مكتمل" ? "#e8f5e9" : "#fff8e1";

  const formatDate = (ts) => {
    const d = ts?.toDate ? ts.toDate() : new Date(ts);
    return d.toISOString().split("T")[0];
  };

  // =============================
  // 📌 واجهة ميثم برحيه
  // =============================
    // ✅ أضف هذا الجزء
  if (!partner) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <Typography variant="h6">جاري تحميل بيانات ميثم...</Typography>
      </Box>
    );
  }

  return (
    <Box dir="rtl" sx={{ width: "100%", px: 3, mt: 4 }}>
      {/* Header */}
      <Box textAlign="center" sx={{ mb: 4 }}>
        <Avatar
          src={partner?.logoUrl}
          sx={{
            width: 90,
            height: 90,
            margin: "0 auto",
            border: "2px solid #1976d2",
            cursor: "pointer",
          }}
          onClick={() => setOpenProfile(true)}
        />

        <Typography variant="h4" fontWeight="bold" sx={{ mt: 2 }}>
ميثم برحيه        </Typography>

        <Typography variant="body2" color="text.secondary">
      


      {/* ===== الإحصائيات ===== */}
      
      {localStorage.getItem("username") === "admin" && (
  <Box sx={{ textAlign: "center", mt: 3 }}>
   <Button
  variant="contained"
  sx={{
    backgroundColor: "#2e7d32", // أخضر غامق
    "&:hover": {
      backgroundColor: "#1b5e20",
    },
    fontWeight: "bold",
    px: 4,
  }}
  onClick={() => setPayDialogOpen(true)}
>
  💵 دفع العمولة
</Button>

  </Box>
)}
     عرض تفاصيل الطلبات والمبيعات الخاصة بـ {PARTNER_NAME}
        </Typography>
      </Box>
      <Grid container spacing={2} direction="row" justifyContent="center">
        <Grid item xs={12} md={4}>
<Paper
  sx={{
    p: 4,
    textAlign: "center",
    height: 140,              // ✅ ارتفاع ثابت
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // ✅ توسيط المحتوى
  }}
>
            <Typography>عدد الطلبات</Typography>
            <Typography fontWeight="bold">{totalOrders}</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
<Paper
  sx={{
    p: 4,
    textAlign: "center",
    height: 140,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }}
>
            <Typography>مجموع المبيعات</Typography>
            <Typography fontWeight="bold">
              {totalAmount.toLocaleString()} د.ع
            </Typography>
          </Paper>
        </Grid>

     <Grid item xs={12} md={4}>
    <Paper
      sx={{
        p: 3,
        textAlign: "right",
        height: 140,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: "#e8f5e9", // ✅ أخضر
        border: "2px solid #2e7d32",
      }}
    >
      <Typography fontWeight="bold">
        💰 قيمة العمولة:{" "}
        {totalCommission.toLocaleString()} د.ع
      </Typography>

      <Typography sx={{ mt: 1 }}>
        ✅ المبلغ المدفوع:{" "}
        {totalPaid.toLocaleString()} د.ع
      </Typography>

      <Typography sx={{ mt: 1, color: "red", fontWeight: "bold" }}>
        ⏳ المتبقي:{" "}
        {remainingCommission.toLocaleString()} د.ع
      </Typography>
    </Paper>
  </Grid>
      </Grid>

      {/* ===== المبيعات الشهرية ===== */}
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
        المبيعات الشهرية
      </Typography>

      <Grid container spacing={2} direction="row" justifyContent="flex-start">
        {monthlyStats.map((m, i) => (
          <Grid key={i} item xs={12} md={4}>
            <Paper sx={{ p: 3, textAlign: "right" }}>
              <Typography fontWeight="bold">
                {m.year}-{String(m.month).padStart(2, "0")}
              </Typography>
              <Typography>📦 {m.count} طلب</Typography>
              <Typography>💰 {m.total.toLocaleString()} د.ع</Typography>
      <Typography>
  💸 العمولة: {m.commission.toLocaleString()} د.ع
</Typography>


            </Paper>
          </Grid>
        ))}
      </Grid>
{/* ===== سجل مدفوعات الشريك (للمدير فقط) ===== */}
{localStorage.getItem("username") === "admin" && payments.length > 0 && (
  <>
    <Typography
      variant="h6"
      fontWeight="bold"
      sx={{ mt: 4, mb: 2 }}
    >
      💳 سجل مدفوعات العمولة
    </Typography>

    <Box sx={{ width: "100%" }}>
      {payments.map((p, index) => {
        const d = p.createdAt?.toDate
          ? p.createdAt.toDate()
          : new Date(p.createdAt);

        const dateStr = `${d.getFullYear()}-${String(
          d.getMonth() + 1
        ).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

        return (
          <Paper
            key={index}
            sx={{
              p: 2,
              mb: 2,
              backgroundColor: "#f1f8e9",
              border: "1px solid #c5e1a5",
            }}
          >
            <Typography>
              📅 التاريخ: <b>{dateStr}</b>
            </Typography>

            <Typography>
              💰 المبلغ المدفوع:{" "}
              <b>{Number(p.amount).toLocaleString()} د.ع</b>
            </Typography>

            <Typography>
              🧾 نوع الدفع:{" "}
              {p.paymentType === "full"
                ? "دفع كامل (تصفير الحساب)"
                : "دفع جزئي"}
            </Typography>

            <Typography>
              💵 طريقة الدفع:{" "}
              {p.method === "cash" ? "كاش" : "حوالة"}
            </Typography>

            {p.receiptUrl && (
              <Typography sx={{ mt: 1 }}>
                <a
                  href={p.receiptUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1976d2",
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                >
                  📎 عرض صورة الوصل
                </a>
              </Typography>
            )}
          </Paper>
        );
      })}
    </Box>
  </>
)}

      {/* ===== تفاصيل المبيعات ===== */}
   {/* ===== تفاصيل المبيعات ===== */}
<Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
  تفاصيل المبيعات
</Typography>

<Box sx={{ width: "100%" }}>
  {orders.map((o) => {
    const d = o.createdAt?.toDate ? o.createdAt.toDate() : new Date();
    const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
    const timeStr = `${String(d.getHours()).padStart(2, "0")}:${String(
      d.getMinutes()
    ).padStart(2, "0")}`;

    return (
      <Box
        key={o.id}
        sx={{
          background: "#FFE7C2",
          p: 2,
          mb: 2,
          borderRadius: "8px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
        }}
      >
        {/* السطر العلوي: التاريخ + الوقت + مصدر الطلب */}
        <Typography sx={{ fontSize: "14px", color: "#555", mb: 1 }}>
          {dateStr} | {timeStr} | مصدر الطلب: {PARTNER_NAME}
        </Typography>

        {/* السطر الثاني: الاسم + رقم + محافظة + سعر */}
        <Typography sx={{ fontSize: "15px" }}>
          الاسم: <b>{o.customerName || "بدون اسم"}</b>
        { o.source === "ارت تاتش" ? (
  <Typography sx={{ fontSize: "14px", color: "green", mt: 1 }}>
    النسبة  : 5%
  </Typography>
) : o.maythamCommission ? (
  <Typography sx={{ fontSize: "14px", color: "green", mt: 1 }}>
    النسبة  : {o.maythamCommission}%
  </Typography>
) : (
  <Typography sx={{ fontSize: "14px", color: "gray", mt: 1 }}>
    النسبة  : غير محددة
  </Typography>
)}

          {o.customerPhone && <> | رقم الزبون: {o.customerPhone}</>}
          {o.governorate && <> | المحافظة: {o.governorate}</>}
          {typeof o.price === "number" && (
            <>
              {" "}
              | السعر: <b>{o.price.toLocaleString()} د.ع</b>
            </>
          )}
          {/* رابط الطلب (Google Drive) */}


        </Typography>

        {/* رابط الصورة (اختياري) */}
        {o.orderImageUrl && (
          <Typography sx={{ mt: 1 }}>
            <a
              href={o.orderImageUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#1976d2",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              🔗 عرض الصورة
            </a>
          </Typography>
        )}
      </Box>
    );
  })}
</Box>


      {/* ===== نافذة البروفايل ===== */}
      <Dialog open={openProfile} onClose={() => setOpenProfile(false)} dir="rtl">
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          ملف الشريك
        </DialogTitle>

        <DialogContent sx={{ minWidth: 350 }}>
          <Box textAlign="center" mb={2}>
            <Avatar
              src={partner?.logoUrl || ""}
              sx={{
                width: 100,
                height: 100,
                margin: "auto",
                border: "2px solid #1976d2",
              }}
            />

            <Button
              variant="outlined"
              component="label"
              sx={{ mt: 1 }}
              disabled={uploading}
            >
              {uploading ? "جاري الرفع..." : "تغيير الصورة"}
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleLogoUpload}
              />
            </Button>
          </Box>

          <TextField
            label="اسم الشركة"
            fullWidth
            sx={{ mb: 2 }}
            value={partner?.name || ""}
            onChange={(e) => setPartner({ ...partner, name: e.target.value })}
          />

          <TextField
            label="رقم الهاتف"
            fullWidth
            sx={{ mb: 2 }}
            value={partner?.phone || ""}
            onChange={(e) => setPartner({ ...partner, phone: e.target.value })}
          />

          <TextField
            label="الموقع الإلكتروني"
            fullWidth
            sx={{ mb: 2 }}
            value={partner?.website || ""}
            onChange={(e) => setPartner({ ...partner, website: e.target.value })}
          />

          <TextField
            label="ملاحظات"
            fullWidth
            multiline
            rows={3}
            value={partner?.notes || ""}
            onChange={(e) => setPartner({ ...partner, notes: e.target.value })}
          />
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Button variant="contained" onClick={handleSaveProfile}>
            حفظ
          </Button>
          <Button variant="outlined" onClick={() => setOpenProfile(false)}>
            إلغاء
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
  open={payDialogOpen}
  onClose={() => setPayDialogOpen(false)}
  fullWidth
  maxWidth="sm"
  dir="rtl"
>
  <DialogTitle>💵 دفع عمولة الشريك</DialogTitle>

  <DialogContent dividers>
    {/* نوع الدفع */}
    <TextField
      select
      fullWidth
      label="نوع الدفع"
      sx={{ mb: 2 }}
      value={paymentType}
      onChange={(e) => setPaymentType(e.target.value)}
    >
      <MenuItem value="full">دفع كامل (تصفير الحساب)</MenuItem>
      <MenuItem value="partial">دفع جزء من العمولة</MenuItem>
    </TextField>

    {/* مبلغ الدفع (يظهر فقط إذا جزئي) */}
    {paymentType === "partial" && (
      <TextField
        fullWidth
        label="مبلغ الدفع"
        type="number"
        sx={{ mb: 2 }}
        value={paymentAmount}
        onChange={(e) => setPaymentAmount(e.target.value)}
      />
    )}

    {/* طريقة الدفع */}
    <TextField
      select
      fullWidth
      label="طريقة الدفع"
      sx={{ mb: 2 }}
      value={paymentMethod}
      onChange={(e) => setPaymentMethod(e.target.value)}
    >
      <MenuItem value="cash">كاش</MenuItem>
      <MenuItem value="transfer">حوالة</MenuItem>
    </TextField>

    {/* صورة الوصل (إذا حوالة) */}
    {paymentMethod === "transfer" && (
      <Button variant="outlined" component="label">
        📤 رفع صورة الوصل
        <input
          hidden
          type="file"
          accept="image/*"
          onChange={(e) => {
            setReceiptFile(e.target.files[0] || null);
            e.target.value = "";
          }}
        />
      </Button>
    )}
    {paymentMethod === "transfer" && (
      <UploadPreview
        files={receiptFile ? [receiptFile] : []}
        onChange={(list) => setReceiptFile(list[0] || null)}
      />
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setPayDialogOpen(false)}>
      إلغاء
    </Button>

    <Button
      variant="contained"
      color="success"
      disabled={savingPayment}
      onClick={async () => {
        try {
          if (!paymentType || !paymentMethod) {
            alert("يرجى إكمال جميع الحقول");
            return;
          }

          setSavingPayment(true);

          let receiptUrl = "";

          if (paymentMethod === "transfer" && receiptFile) {
            const storageRef = ref(
              storage,
              `partnerPayments/${PARTNER_ID}/${Date.now()}_${receiptFile.name}`
            );
            await uploadBytes(storageRef, receiptFile);
            receiptUrl = await getDownloadURL(storageRef);
          }

          await addDoc(collection(db, "partnerPayments"), {
            partnerId: PARTNER_ID,
            partnerName: PARTNER_NAME,
         amount:
  paymentType === "full"
    ? remainingCommission
    : Number(paymentAmount),

            paymentType,
            method: paymentMethod,
            receiptUrl,
            createdAt: new Date(),
            createdBy: "admin",
          });
await fetchPayments();   // ✅ تحديث المدفوعات

          alert("✅ تم تسجيل الدفع بنجاح");
          setPayDialogOpen(false);
          setPaymentType("");
          setPaymentMethod("");
          setPaymentAmount("");
          setReceiptFile(null);
        } catch (err) {
          console.error(err);
          alert("❌ حدث خطأ أثناء الحفظ");
        } finally {
          setSavingPayment(false);
        }
      }}
    >
      تأكيد الدفع
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default PartnerDashboardMitham;
